import { render, staticRenderFns } from "./ArrowExpandVertical.vue?vue&type=template&id=2a76e86f"
import script from "./ArrowExpandVertical.vue?vue&type=script&lang=js"
export * from "./ArrowExpandVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports